import { createSelector } from 'reselect'

import { codecTypes } from '../config'
import { AVAILABLE, OCCUPIED, OFFLINE } from '../constants/status'
import { subscriberFilter, subscriberSort } from '../helper/subscriber'

const config = state => state.config
const subscribers = state => state.subscribers
const calls = state => state.calls
const user = state => state.user
const preferences = state => state.preferences
const pstnNumbers = state => state.config.pstnNumbers

export const getSubscribers = createSelector(
    [subscribers, calls, config],
    (subscribers, calls, config) => {
        subscribers = subscribers.map(subscriber => {
            const { username } = subscriber
            const unit_id = username[0] == 0 || username[0] == 9 ? null : username[2]
            const extended = {
                unit_id,
                unit: username[0] == 0 ? 'Other' : username[0] == 9 ? 'Test' : config.units.filter(u => u.key == unit_id).map(u => u.name)[0] || 'Other',
                codec: codecTypes.filter(c => c.key == username[0]).map(c => c.name)[0] || '',
                device: config.devices.filter(d => d.key == subscriber.device_type).map(d => d.name)[0] || '',
                site_name: config.sites.filter(site => site.key == subscriber.site).map(site => site.name)[0] || '',
                status: subscriber.online ? AVAILABLE : OFFLINE
            }
            return Object.assign({}, subscriber, extended)
        })
        calls.forEach(call => {
            const source = subscribers.filter(s => s.username === call.username)[0]
            const destination = subscribers.filter(s => s.username === call.dst_username)[0]
            if (source) {
                Object.assign(source, {
                    status: OCCUPIED,
                    activeCall: Object.assign({}, call, { destination })
                })
            }
            if (destination) {
                Object.assign(destination, {
                    status: OCCUPIED,
                    activeCall: Object.assign({}, call, { destination: source })
                })
            }
        })
        return subscribers
    }
)

export function getSubscriber(state, username) {
    return getSubscribers(state).filter(s => s.username === username)[0]
}

export const getCalls = createSelector(
    [calls, getSubscribers],
    (calls, subscribers) => subscribers.length ? calls.map(call => mapCall(call, subscribers)) : []
)

function mapCall(call, subscribers) {
    return Object.assign({}, call, {
        source: subscribers.filter(s => s.username === call.username)[0],
        destination: subscribers.filter(s => s.username === call.dst_username)[0],
    })
}

export const getUser = createSelector(
    [user],
    user => Object.assign({}, user, {
        getUnits: getUnits.bind(user),
        isInUnit: isInUnit.bind(user),
        isUnitAdmin: isUnitAdmin.bind(user)
    })
)

export const getMainViewSubscribers = createSelector(
    [getSubscribers, preferences, getUser],
    (subscribers, { filter, sortOrder }, user) => subscribers.filter(subscriberFilter(filter, user)).sort(subscriberSort(sortOrder))
)

export const getAvailablePstnNumbers = createSelector(
    [subscribers, pstnNumbers],
    (subscribers, pstnNumbers) => {
        const usedNumbers = subscribers.map(s => s.did).filter(n => n)
        return pstnNumbers && pstnNumbers.filter(n => usedNumbers.indexOf(n) < 0 && n != '') || []
    }
)

function getUnits() {
    return this.roles ? this.roles.filter(r => !isNaN(r.unit)).map(r => r.unit) : []
}

function isInUnit(unit_id) {
    return this.isGlobalAdmin || this.roles && (unit_id == 7 && this.roles.filter(r => r.role === 'admin').length > 0 || this.roles.filter(r => r.unit == unit_id).length > 0)
}

function isUnitAdmin(unit_id) {
    return this.isGlobalAdmin || this.roles && this.roles.filter(r => (r.unit == unit_id || unit_id == 7) && r.role === 'admin').length > 0
}



// WEBPACK FOOTER //
// ./selectors/index.js